import truckstopLogo from "../assets/truckstop_logos/Truckstop Logo - White.png";
import truckstopLogoBlack from "../assets/truckstop_logos/Truckstop Logo - Default.png";
import directFreightLogo from "../assets/direct-freight-logo.png";

export const formatDate = (dateStr) => {
  try {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) {
      console.warn("Invalid date:", dateStr);
      return dateStr || "N/A";
    }
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      timeZone: "UTC",
    });
  } catch (e) {
    console.error("Error formatting date:", e, dateStr);
    return dateStr || "N/A";
  }
};

export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return "Call for rate";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const formatMiles = (miles) => {
  if (!miles) return "N/A";
  return `${Math.round(miles).toLocaleString()} miles`;
};

export const capitalizeCity = (city) => {
  if (!city) return "";
  return city
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const capitalizeWordHelper = (word) => {
  if (word.length <= 5) {
    return word;
  }
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

export const capitalizeCompanyName = (name) => {
  if (!name) return "";
  return name
    .split(" ")
    .map((word) => capitalizeWordHelper(word))
    .join(" ");
};

export const getDataSourceBadge = (dataSource, theme) => {
  if (dataSource === "truckstop") {
    if (theme === "dark" || theme === "system") {
      return (
        <img
          src={truckstopLogo}
          alt="Truckstop"
          style={{
            height: "14px",
            width: "auto",
            objectFit: "contain",
            marginLeft: "8px",
          }}
        />
      );
    } else {
      return (
        <img
          src={truckstopLogoBlack}
          alt="Truckstop"
          style={{
            height: "14px",
            width: "auto",
            objectFit: "contain",
            marginLeft: "8px",
          }}
        />
      );
    }
  }
  if (dataSource === "tql" || dataSource === "TQL") {
    return "TQL";
  }

  if (dataSource === "C.H. Robinson") {
    return "CHR";
  }

  if (dataSource === "parade") {
    return "Parade";
  }

  return (
    <img
      src={directFreightLogo}
      alt="Direct Freight"
      style={{
        height: "20px",
        width: "auto",
        objectFit: "contain",
        marginLeft: "8px",
      }}
    />
  );
};
